module.exports = __webpack_public_path__ + "51cfe82f501fa72b0af2d7e353f648e5.png";